import http from '@/plugins/axios/axios';
import { CHVAE_TOKEN } from '@/global';

export default class EstatisticaAdminService {

    constructor() {
        this.baseUrl = process.env.VUE_APP_BASE_URL_MANUTE
        this.token = JSON.parse(sessionStorage.getItem(CHVAE_TOKEN)); 
    }

    busarAcumulado() {       
        return http.request({
            method: 'get', 
            headers: {Authorization: 'Bearer '+this.token.valor},
            url: this.baseUrl + '/estatisticas'
        });
    }

    listarPorPeriodo(dataInicio, dataFinal) {       
        return http.request({
            method: 'get', 
            headers: {Authorization: 'Bearer '+this.token.valor},
            url: this.baseUrl + `/estatisticas/periodo?dataInicio=${dataInicio}&dataFinal=${dataFinal}`
        });
    }
}